// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderMenu_header__68vDJ","burger":"HeaderMenu_burger__1FU0m","menu":"HeaderMenu_menu__3gnIQ","container":"HeaderMenu_container__1WtK2"};